import { postData, getData, putData, deleteData, patchData } from '../axiosServices'

const customBaseUrl = process.env.REACT_APP_REVIEW_APP_API_URL ? `${process.env.REACT_APP_REVIEW_APP_API_URL}/api/v1/` : undefined;

export const getAllReviewTopics = async (learner_code) => {
    let url = `learnerTrackScore/${learner_code}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }

    return getData(url, { headers });
};

export const getAllTrackScoreDetails = async (learner_id, topic_id, module_id, makerPlan_id) => {
    let url = `learnerTrackScore/detailedTrackScore?learner_id=${learner_id}&topic_id=${topic_id}&module_id=${module_id}&maker_plan_id=${makerPlan_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }

    return getData(url, { headers });
};
export const addReview = async (obj) => {
    let url = `learnerTrackScore`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, obj, { headers });
};
export const getLearnerNotes = async (learner_id, makerPlan_id, module_id, topic_id) => {
    let url = `learnerTrackNote/learners/${learner_id}/makerplan/${makerPlan_id}/modules/${module_id}/topics/${topic_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const addLearnerNotes = async (obj) => {
    let url = `learnerTrackNote`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, obj, { headers });
};
export const updateLearnerNotes = async (note_id, obj) => {
    let url = `learnerTrackNote/${note_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, obj, { headers });
};
export const DeleteLearnerNotes = async (note_id) => {
    let url = `learnerTrackNote/${note_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return deleteData(url, { headers });
};

export const getLearnerList = (coeID, labID) => {
    let url;
    if (labID) {
        url = `learners/coeId/${coeID}/labId/${labID}`;
    } else {
        url = `coe/${coeID}/learners`;
    }
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const updatePublished = async (learner_id, makerPlan_id, module_id, topic_id, obj) => {
    let url = `learnerTrackScore/learners/${learner_id}/makerplan/${makerPlan_id}/modules/${module_id}/topics/${topic_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, obj, { headers });
};

export const ReviewStatus = Object.freeze({
    REVIEW_PENDING: 'REVIEW_PENDING',
    EVALUATION_PENDING: 'EVALUATION_PENDING',
    EVALUATION_FAILED: 'EVALUATION_FAILED',
    LC_PENDING: 'LC_PENDING',
    VERIFICATION_PENDING: 'VERIFICATION_PENDING',
    COMPLETED: 'COMPLETED',
    EMAIL_QUEUED: 'EMAIL_QUEUED',
    EMAIL_SENDING: 'EMAIL_SENDING',
    EMAIL_FAILED: 'EMAIL_FAILED',
    TLC_PUBLISHED: 'TLC_PUBLISHED',
});

export const getMentorReviewsDashboard = async (paramsOrCoe, lab_id, page = 1, limit = 10, additionalFilters = {}) => {
    let paramsObj = {};
    if (typeof paramsOrCoe === 'object' && paramsOrCoe !== null) {
        paramsObj = { ...paramsOrCoe };
    } else {
        paramsObj = {
            coe_id: paramsOrCoe,
            lab_id: lab_id,
            page: page,
            limit: limit,
            ...additionalFilters
        };
    }

    if (paramsObj.coeId && !paramsObj.coe_id) {
        paramsObj.coe_id = paramsObj.coeId;
    }
    delete paramsObj.coeId;

    if (paramsObj.status && typeof paramsObj.status === 'string') {
        const upper = paramsObj.status.trim().toUpperCase();
        const allowedStatuses = [
            'REVIEW_PENDING', 'EVALUATION_PENDING', 'EVALUATION_FAILED',
            'LC_PENDING', 'VERIFICATION_PENDING', 'EMAIL_QUEUED',
            'EMAIL_SENDING', 'EMAIL_FAILED', 'TLC_PUBLISHED', 'COMPLETED'
        ];
        if (allowedStatuses.includes(upper)) {
            paramsObj.status = upper;
        }
    }

    const queryParams = new URLSearchParams();
    Object.keys(paramsObj).forEach(key => {
        const val = paramsObj[key];
        if (val !== undefined && val !== null && val !== '' && val !== 'all') {
            queryParams.append(key, val);
        }
    });

    let url = `mentor/learner-reviews?${queryParams.toString()}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers }, customBaseUrl);
};

export const getSubmissionDetails = async (learnerId, reviewProgressId) => {
    let url = `mentor/learners/${learnerId}/reviews/${reviewProgressId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers }, customBaseUrl);
};

export const saveMentorFeedback = async (learnerId, reviewProgressId, payload) => {
    let url = `mentor/learners/${learnerId}/reviews/${reviewProgressId}/score`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return patchData(url, payload, { headers }, customBaseUrl);
};

export const verifyMentorReviews = async (payload) => {
    let url = `mentor/reviews/verify`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, payload, { headers }, customBaseUrl);
};

export const publishMentorReviews = async (payload) => {
    let url = `mentor/reviews/publish`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, payload, { headers }, customBaseUrl);
};

export const bulkEmailMentorReviews = async (payload) => {
    let url = `mentor/reviews/bulk-email`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, payload, { headers }, customBaseUrl);
};

export const uploadLCScores = async (formData) => {
    let url = `mentor/lc-scores/upload`;
    const headers = {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, formData, { headers }, customBaseUrl);
};

export const getTlcScores = async (reviewId, learnerId) => {
    let url = `tlc/details?reviewId=${reviewId}&learnerId=${learnerId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers }, customBaseUrl);
};

export const getReviewNames = async () => {
    let url = `mentor/review-names`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers }, customBaseUrl);
};

export const getConductedReviewNames = async (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
        const val = params[key];
        if (val !== undefined && val !== null && val !== '' && val !== 'all') {
            queryParams.append(key, val);
        }
    });
    const qs = queryParams.toString();
    let url = `mentor/conducted-review-names${qs ? `?${qs}` : ''}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return getData(url, { headers }, customBaseUrl);
};

export const getConductedReviewTitles = async () => {
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return getData('mentor/conducted-review-titles', { headers }, customBaseUrl);
};

export const getConductedReviewsReport = async (params = {}) => {
    const queryParams = new URLSearchParams();

    const coeId = params.coe_id || params.coeId;
    if (coeId) queryParams.append('coe_id', coeId);

    if (params.semester !== undefined && params.semester !== null && params.semester !== '' && params.semester !== 'all') {
        queryParams.append('semester', params.semester);
    }

    const reviewName = params.review_name || params.reviewName;
    if (reviewName && reviewName !== 'all') {
        queryParams.append('review_name', reviewName);
    }

    const enrolmentYear = params.enrolment_year || params.enrolmentYear;
    if (enrolmentYear) queryParams.append('enrolment_year', enrolmentYear);

    const passoutYear = params.passout_year || params.passoutYear;
    if (passoutYear) queryParams.append('passout_year', passoutYear);

    const reviewTitle = params.review_title || params.reviewTitle;
    if (reviewTitle && reviewTitle !== 'all') {
        queryParams.append('review_title', reviewTitle);
    }

    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.lab_id || params.labId) queryParams.append('lab_id', params.lab_id || params.labId);

    const qs = queryParams.toString();
    let url = `mentor/report/conducted-reviews${qs ? `?${qs}` : ''}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return getData(url, { headers }, customBaseUrl);
};

export const getConductedReviewLabStats = async (reviewId, params = {}) => {
    const queryParams = new URLSearchParams();
    const coeId = params.coe_id || params.coeId;
    if (coeId) queryParams.append('coe_id', coeId);

    if (params.semester !== undefined && params.semester !== null && params.semester !== '' && params.semester !== 'all') {
        queryParams.append('semester', params.semester);
    }

    const qs = queryParams.toString();
    const encodedReviewId = encodeURIComponent(reviewId);
    let url = `mentor/report/conducted-reviews/${encodedReviewId}/lab-stats${qs ? `?${qs}` : ''}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return getData(url, { headers }, customBaseUrl);
};